import mulchingBeds from "@/assets/services/mulching-beds.jpg";
import snowRemoval from "@/assets/services/snow-removal.jpg";
import aerationOverseeding from "@/assets/services/aeration-overseeding.jpg";
import dethatching from "@/assets/services/dethatching.jpg";
import seasonalCleanup from "@/assets/services/seasonal-cleanup.jpg";

export interface Project {
  slug: string;
  title: string;
  location: string;
  description: string;
  highlights: string[];
  image_url?: string | null;
}

export const projects: Project[] = [
  {
    slug: "maple-grove-weekly-mowing",
    title: "Weekly Lawn Maintenance",
    location: "Maple Grove, MN",
    description: "Comprehensive weekly lawn care program for a 1/2 acre residential property. Professional mowing with precision striping, edging, and trimming to keep this lawn looking pristine all season.",
    highlights: ["Weekly mowing service", "Professional striping pattern", "Edging & trimming included"],
    image_url: seasonalCleanup,
  },
  {
    slug: "plymouth-mulch-installation",
    title: "Mulch & Landscape Bed Refresh",
    location: "Plymouth, MN",
    description: "Complete landscape bed refresh including weed removal, edging, and fresh premium hardwood mulch installation. Transformed tired beds into stunning focal points.",
    highlights: ["Premium hardwood mulch", "Bed edging & cleanup", "Weed barrier installation"],
    image_url: mulchingBeds,
  },
  {
    slug: "rogers-aeration-overseeding",
    title: "Aeration & Overseeding",
    location: "Rogers, MN",
    description: "Fall core aeration and overseeding service to revitalize a thin, compacted lawn. This combination promotes deeper root growth and fills in bare spots for a thicker, healthier lawn.",
    highlights: ["Core aeration", "Premium grass seed", "Starter fertilizer application"],
    image_url: aerationOverseeding,
  },
  {
    slug: "rogers-dethatching",
    title: "Spring Dethatching Service",
    location: "Rogers, MN",
    description: "Professional dethatching to remove excessive thatch buildup that was preventing water and nutrients from reaching the grass roots. Lawn showed dramatic improvement within weeks.",
    highlights: ["Power dethatching", "Thatch removal & cleanup", "Improved lawn health"],
    image_url: dethatching,
  },
  {
    slug: "corcoran-fall-cleanup",
    title: "Seasonal Fall Cleanup",
    location: "Corcoran, MN",
    description: "Complete fall cleanup service including leaf removal, bed cleanup, and lawn preparation for winter. Professional equipment ensures thorough cleanup without damaging turf.",
    highlights: ["Complete leaf removal", "Bed & lawn cleanup", "Winter preparation"],
    image_url: seasonalCleanup,
  },
  {
    slug: "medina-snow-removal",
    title: "Residential Snow Removal",
    location: "Medina, MN",
    description: "Reliable residential snow removal service keeping driveways and walkways clear and safe throughout Minnesota winters. Quick response times after snowfall.",
    highlights: ["Driveway clearing", "Walkway shoveling", "De-icing treatment"],
    image_url: snowRemoval,
  },
  {
    slug: "medina-lawn-care-program",
    title: "Complete Lawn Care Program",
    location: "Medina, MN",
    description: "Full-service lawn care program including weekly mowing and seasonal services. This property went from struggling grass to a neighborhood showpiece.",
    highlights: ["Weekly maintenance", "Seasonal cleanups", "Aeration & overseeding"],
    image_url: aerationOverseeding,
  },
];

export const getProjectBySlug = (slug: string): Project | undefined => {
  return projects.find((project) => project.slug === slug);
};
